import { createContext, useContext } from 'react';
import type { CoreStageContextT } from './types';
const defaultContext: CoreStageContextT = {
  stage: new EventTarget(),
  onStage: true,
  addInterceptor: () => {},
  removeInterceptor: () => {},
  getStageDimension: () => [0, 0],
  getStageCenter: () => [0, 0],
  getStageSettings: () => ({
    x: 0,
    y: 0,
    scale: 1,
    rotation: 0
  }),
  changeStageSettings: () => {},
  setStageSettings: () => {},
  fitToScreen: () => {}
};
export const CoreStageContext = createContext<CoreStageContextT>(defaultContext);
export function useCoreStageContext(): CoreStageContextT {
  return useContext(CoreStageContext);
}